// contexts/UserContext.tsx
import { createContext, useContext, useState, useEffect } from "react";
import { setupAPIclient } from '../../services/setupAPIclient';
import LocalStorage from "../../helpers/localstorage";



type User = {
    name: string,
    email: string,
    number_phone: string,
    password:string,
    can_edit:boolean,
    can_view: boolean
};

type UserContextType = {
  user: User | null;
  loading: boolean;
};

const UserContext = createContext<UserContextType>({
  user: null,
  loading: true,
});

export function useUser() {
  return useContext(UserContext);
}

export function UserProviderloginSubmaster({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  let localStorage = new LocalStorage();


   

useEffect(() => {
  async function fetchUser() {
    try {
      const token = localStorage.getAuthTokenUserToSubmaster();
      if (!token) return;

      const ApiClient = setupAPIclient(token);
      const response = await ApiClient.post("/auth/get/loginUserToSubmaster");

      console.log("API RESPONSE:", response.data);

      setUser(response.data);
    } catch (error) {
      console.error("Erro ao buscar dados do usuário:", error);
    } finally {
      setLoading(false);
    }
  }

  fetchUser();
}, []);


  return (
    <UserContext.Provider value={{ user, loading }}>
      {children}
    </UserContext.Provider>
  );
}
